import React from "react"
import './AboutMe.css';

function AboutMe () {
  return (
    <div className="aboutMe-content">
      <h1 className="headerLabel">About Me</h1>
      <p className="description">I'm an aspiring Software Dev with a Computer Engineering background passionate about IT and building new things! From web apps in large distributed banking systems to AI engineered services to even game development, I'm always looking to put my skills to building and learning new projects.</p>
    </div>
  )
};

export default AboutMe;
